/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
<template lang="html">
  <div class="centerx" ref="popupContainer" style="min-width: 1000px;">

	<vs-popup :active.sync="validationPopup" title="Veuillez confirmer la suppression du document:">
		<h2>Le document "{{docName}}" sera supprimé.</h2>
		<div class="vx-row">
			<div class="vx-col sm:w-1/2">
				<vs-button class="mt-2 w-full" @click="deleteDoc()">Confirmer</vs-button>
			</div>
			<div class="vx-col sm:w-1/2">
				<vs-button class="mt-2 w-full" @click="cancelDelete()">Annuler</vs-button>
			</div>
		</div>
	</vs-popup>

	<vs-popup :active.sync="showAllOrderPopup" title="Toutes les commandes du contrat">
		<vx-card class="mb-1">
			<div class="vx-row mb-2">
				<div class="vx-col mb-2">
					<h3>
						Filtres :
					</h3>
				</div>

				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="orderProductFilter"
						class="w-full select-large"
						placeholder="Consultant Rankwell"
						autocomplete
						@change="ordersFilter(allOrders)"
					>
						<vs-select-item
							value=""
							text="Prestation"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="productOptions[0].category_name == products_categories[item.category - 1] ? products_categories[item.category - 1] + ' - ' + item.perform : 'Autre - ' + item.perform"
							v-for="(item, index) in productOptions"
							class="w-full"
						/>
					</vs-select>
				</div>

				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="orderAccountmanagerFilter"
						class="w-full select-large"
						placeholder="Consultant Rankwell"
						autocomplete
						@change="ordersFilter(allOrders)"
					>
						<vs-select-item
							value=""
							text="Consultant"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.firstname + ' ' + item.lastname"
							v-for="(item, index) in accountmanagerOptions"
							class="w-full"
						/>
					</vs-select>
				</div>

				<div class="vx-col px-1 mb-2">
					<vs-input class="inputx" placeholder="Brief" v-model="briefFilter" @input="ordersFilter(allOrders)"/>
				</div>

				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="orderStatusFilter"
						class="w-full select-large"
						placeholder="Statut (Sélection multiple)"
						multiple
						autocomplete
						@change="ordersFilter(allOrders)"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in orderStatusOptions"
							class="w-full"
						/>
					</vs-select>
				</div>

				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="orderBillableFilter"
						class="w-full select-large"
						placeholder="Facturable"
						@change="ordersFilter(allOrders)"
					>
						<vs-select-item
							value=""
							text="Tous"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="String(item.value)"
							:text="item.text"
							v-for="(item, index) in billableOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
			</div>
			<div class="vx-row w-full mt-2">
				<div class="vx-col">
					<strong>Nombre de commandes : {{ cloneListOrders.length }}</strong>
				</div>
			</div>
		</vx-card>
		<CommandeTable
			:orders="cloneListOrders"
			:contract="contract" :readOnly="false"
			@refresh-orders="refreshOrders"
			@duplicate-order="duplicateOrder($event)"
			ref="orderTable"
			:fromAllOrders= "true"
			style="margin-left:-10px; width: calc(100% + 20px);"
		/>
	</vs-popup>

    <vs-popup
		:title="'Contrat n° ' + contract.id + '\n' + (contract.society_name ? contract.society_name : '')"
		:active.sync="isPopupActive"
		background-color-popup="#F2F3F4"
		:style="highZIndex ? 'z-index: 53003;' : ''"
		:key="popupKey"
    >
      <div class="container-fluid ml-2"
        id="contractPopup"
		style="max-width: 1024px; padding: 25px;"
      >
        <div class="vx-row w-full contract-status">
            <div class="vx-col w-1/2">
				<div class="vx-col sm:w-1/4 w-full mb-2 flex" v-if="contractToModify.edit && $acl.check('sadmin')">
					<vx-input-group class="w-full bottom">
						<vs-select
							autocomplete
							v-model="contractStatus"
							class="w-full select-medium mr-2"
							placeholder="Statut"
						>
							<vs-select-item
								:key="index"
								:value="item.index"
								:text="item.text"
								v-for="(item, index) in sAdminStatusOptions"
								class="w-full"
							/>
						</vs-select>
					</vx-input-group>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2 flex" v-else-if="contractToModify.edit && $acl.check('admin') && contract.status !== 5  && contract.status !== 4">
					<vx-input-group class="w-full bottom">
						<vs-select
							autocomplete
							v-model="contractStatus"
							class="w-full select-medium mr-2"
							placeholder="Statut"
						>
							<vs-select-item
								:key="index"
								:value="item.index"
								:text="item.text"
								v-for="(item, index) in adminStatusOptions"
								class="w-full"
							/>
						</vs-select>
					</vx-input-group>
				</div>
				<vs-chip
				v-else
				:key= "contractStatus"
					style="width: 95px; height:28.78px; border-radius: 6px; align-self: end; font-size: 12px;"
					:color="getContractStatusColor(Number(String(contractStatus)[0]))"
				>
					{{ getContractStatus(Number(String(contractStatus)[0]))}}
				</vs-chip>
            </div>
            <div v-if="activeUser.role != '2' && activeUser.type != '7'" class="vx-col w-1/2 title-btn" style="text-align: right;" :key="refreshEdit">
                <span class="mr-auto">
					<vs-button v-if="!contractToModify.edit" style="border-radius: 1px 6px 6px 6px; width: 176px; height: 32.9px; white-space: nowrap;" @click="modifyContract">
						<div style="display: inline-block; vertical-align: middle;">
							<div class="pen1"></div>
							<div class="pen2">
								<div class="pen3"></div>
								<div class="pen4"></div>
							</div>
						</div>
						<div style="display: inline-block; margin-left: 5px;">Modifier ce contrat</div>
					</vs-button>
					<vs-button v-if="contractToModify.edit" id="modifyButton" style="border-radius: 1px 6px 6px 6px; width: 176px; height: 32.9px; white-space: nowrap;"
					 @click="updateContract();" class="vs-con-loading__container">
						<div style="display: inline-block; vertical-align: middle;">
							<div class="pen1"></div>
							<div class="pen2">
								<div class="pen3"></div>
								<div class="pen4"></div>
							</div>
						</div>
						<div style="display: inline-block; margin-left: 5px;">Verrouiller</div>
					</vs-button>
				</span>
            </div>
        </div>
		<div class="flex mb-5">
			<!-- Status  v-if ="contractStatus==3" -->
			<div class="vx-row w-full card-block" >
				<vs-card class="w-1/2 card-block-child" style="padding-left: 35px; padding-right: 20px;">
					<div v-if= "!contractToModify.edit && (pauseStartDate || pauseEndDate)
					//  contractStatus==30
					 " class="flex">
						<div v-if = "pauseStartDate"
						style="display: flex; flex-direction: column;">
							<div class="vx-row  mt-2 vertical-start">
								<span class="title w-full" style="margin-bottom: 5px;">Pause Date de début</span>
								<span class="value"
								><b>{{
									convertDDMMYYY(pauseStartDate) || nullValueMsg
								}}</b>
								</span>
							</div>
						</div>
						<div v-if = "pauseEndDate" 
						style="display: flex; flex-direction: column;">
							<div class="vx-row  mt-2 vertical-start">
								<span class="title w-full" style="margin-bottom: 5px;">Pause Date de fin</span>
								<span :class="{'red': isDateBeforeToday(pauseEndDate), 'value': true}"
								><b >{{
									convertDDMMYYY(pauseEndDate) || nullValueMsg
								}}</b>
								</span>
							</div>
						</div>


					</div>
					<div v-if= "contractToModify.edit 
					// && contractStatus==30
					" class="flex">
						<div class="w-full mr-10">
							<label for="" class="vs-select--label" style="color: red">Pause Date de début *</label>
				 			 <flat-pickr
								  class="w-full"
								  v-model="pauseStartDate"
								  
								  :config="configDatePicker"
				 			 />
				 			 <vx-tooltip v-if="validators['missionStartDate'] && validators['missionStartDate'].errText !== ''" :text="errText('missionStartDate')" class="ml-3" style="display: inline-block;">
								  <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				 			 </vx-tooltip>
			  			</div>
						<div class="w-full ">
							<label for="" class="vs-select--label" >Pause Date de fin</label>
								  <flat-pickr
									  class="w-full"
									  v-model="pauseEndDate"
									  
									  :config="configDatePicker"
								  />
								  <vx-tooltip v-if="validators['missionStartDate'] && validators['missionStartDate'].errText !== ''" :text="errText('missionStartDate')" class="ml-3" style="display: inline-block;">
									  <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
								  </vx-tooltip>
			  				</div>


					</div>

				</vs-card>
			  <!-- DATE -->
			</div>
			<!-- next field -->


		</div>
		<div class="vx-row w-full card-block" style="flex-wrap: nowrap; height: 250px;">
			<vs-card class="w-1/2 card-block-child" style="padding-left: 35px; padding-right: 20px;">
				<div class="vx-row w-full h-50 flex infocard" style="justify-content: space-between; ">
					<div class="vx-row w-1/4 mt-2 vertical-start">
						<span class="title w-full" style="margin-bottom: 5px;">PRESTATION</span>
						<span class="value"><b>{{
							products_categories.length > 0 ? products_categories[contract.delivery - 1] : " "
						}}</b></span>
					</div>
					<div class="vx-row w-1/4 mt-2 vertical-start">
						<span class="title w-full" style="margin-bottom: 5px;">TYPE</span>
						<span class="value"><b>{{getContractTypeName(contract.type) || null
						}}</b></span>
					</div>
					<div class="vx-row w-1/4 mt-2 vertical-start">
						<span class="title w-full" style="margin-bottom: 5px;">CRÉATION</span>
						<span class="value"
						><b>{{
							getDateToFrenchFormat(contract.creation_date) || nullValueMsg
						}}</b>
						</span>
					</div>
					<div class="vx-row w-1/4 mt-2 vertical-start">
						<span class="title w-full" v-if="contract.end_date" style="margin-bottom: 5px;">FIN</span>
						<span class="value" v-if="contract.end_date"><b>{{
							getDateToFrenchFormat(contract.end_date) || nullValueMsg }}</b>
						</span>
					</div>
				</div>
				<div class="vx-row w-full h-50 flex infocard" style="justify-content: space-between;" :key="refreshEdit">
					<div class="vx-row w-1/4 mt-2 flex vertical-start w-full" style="flex-basis: min-content;">
						<span class="title w-full" style="margin-bottom: 5px;">COMMERCIAL</span>
						<vx-tooltip
							v-if="!contractToModify.edit"
							:text="contract.commercial_name"
							position="top"
						>
							<vs-avatar style="border: 1px solid #08B0B9; margin-left: 0;" :text="contract.commercial_name" :src="getCollaboratorAvatar(contract.commercial_id)"/>
						</vx-tooltip>
						<div class="vx-col px-1 mb-2 w-full" style="margin-left: -3px;" v-if="contractToModify.edit">
							<vs-select
								v-model="contractToModify.commercial_id"
								class="w-full select-large"
								autocomplete
							>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.firstname + ' ' + item.lastname"
								v-for="(item, index) in commercialOptions"
								class="w-full"
							/>
							</vs-select>
						</div>
					</div>
					<div class="vx-row w-1/4 mt-2 flex vertical-start infocard-col" style="flex-basis: min-content; margin-left: 4px;">
						<span class="title w-full" style="margin-bottom: 10px;white-space: nowrap;">CONSULTANT LEAD</span>

						<div v-if="!contractToModify.edit && contract.account_manager_avatars && contract.account_manager_avatars.length > 0" class="vx-row center-content" style="margin: -4px;">
							<div class="flex center" v-for="(account_manager_avatar, index) in contract.account_manager_avatars" :key="index">
							<vx-tooltip
								:text="account_manager_avatar.name"
								position="top"
								v-if="account_manager_avatar.is_lead"
							>
								<vs-avatar
									style="border: 1px solid #08B0B9;"
									:text="account_manager_avatar.name"
									:src="getCollaboratorAvatar(account_manager_avatar.users_id)"
									v-if="account_manager_avatar.is_lead"
								/>
							</vx-tooltip>
							</div>
						</div>
						<div class="vx-col px-1 mb-2 w-full" style="margin: -5px 0 0 -3px;" v-if="contractToModify.edit">
							<vs-select
								v-model="leadId"
								class="w-full select-large"
								autocomplete
							>
							<vs-select-item
								:value="0"
								:text="'Consultant Lead'"
								class="w-full"
							/>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.firstname + ' ' + item.lastname"
								v-for="(item, index) in accountmanagerOptions"
								class="w-full"
							/>
							</vs-select>
						</div>
					</div>
					<div class="vx-row w-1/4 mt-2 vertical-start infocard-col">
						<span class="title w-full" v-if="contract.type == 1" style="margin: 0 0 5px 5px;">ENGAGEMENT</span>
						<span class="value" v-if="!contractToModify.edit && contract.type == 1" style="margin-left: 5px;"><b>{{contract.engagement_duration|| 0}} mois</b></span>
						<vs-input class="inputx w-full" style="font-size: 11px;" v-if="contractToModify.edit && contract.type == 1" v-model="contractToModify.engagement_duration" @input="contractToModify.engagement_duration = contractToModify.engagement_duration.replace(/[^\d]/g, '')"/>
					</div>
					<div class="vx-row w-1/4 mt-2 vertical-start infocard-col">
						<span class="title w-full" v-if="contract.type == 1" style="margin-bottom: 5px;">PORTE SORTIE</span>
						<span class="value" v-if="!contractToModify.edit && contract.type == 1"><b>{{getEarlyCancellation(contract.early_cancellation_duration)}}</b></span>
						<vs-input class="inputx w-full" style="font-size: 11px;" v-if="contractToModify.edit && contract.type == 1" v-model="contractToModify.early_cancellation_duration" @input="contractToModify.early_cancellation_duration = contractToModify.early_cancellation_duration.replace(/[^\d]/g, '')"/>
					</div>
				</div>
				<div class="vx-row h-50 infocard" style="display: flex;justify-content: space-between;flex-direction: row;flex-wrap: nowrap;" :key="refreshEdit">
					<div class="vx-row  mt-2 flex flex-col" >
						<span class="title " style="margin-bottom: 5px;text-transform: uppercase;">FACTURATION</span>

						<div class=" mb-2 " style="margin-left: -3px;" v-if="contractToModify.edit">
							<vs-select
								v-model="contractToModify.invoice_period"
								class="w-full  select-large"
								autocomplete
							>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in getFacturationOptionList()"
								class=""
							/>
							</vs-select>
						</div>
						<div v-else>
							<b>
							<!-- getting name -->
							{{getFacturationOptionList().filter(e => contract.invoice_period == e.id).map(ele=>ele.name)[0]}}
						</b>
						</div>
					</div>
					<div class="vx-row  mt-2 flex flex-col " >
						<span class="title " style="margin-bottom: 5px;text-transform: uppercase;"> Délai des paiement </span>
						<div class=" mb-2 " style="margin-left: -3px;" v-if="contractToModify.edit">
							<vs-select
								v-model="contractToModify.invoice_delay_time"
								class=" select-large"
								autocomplete
							>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in getFacturationDelayTime()"
								class=""
							/>
							</vs-select>
						</div>
						<div v-else>
							<b>
							<!-- getting name -->
							{{getFacturationDelayTime().filter(e => contract.invoice_delay_time == e.id).map(ele=>ele.name)[0]}}
						</b>
						</div>
					</div>
					<div class="vx-row  mt-2 flex flex-col " >
						<span class="title " style="margin-bottom: 5px;text-transform: uppercase;"> Mode de paiement </span>
						<div class=" mb-2 " style="margin-left: -3px;" v-if="contractToModify.edit">
							<vs-select
								v-model="contractToModify.invoice_type"
								class=" select-large"
								autocomplete
							>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in getFacturationMethod()"
								class=""
							/>
							</vs-select>
						</div>
						<div v-else>
							<b>
							<!-- getting name -->
							{{getFacturationMethod().filter(e => contract.invoice_type == e.id).map(ele=>ele.name)[0]}}
							</b>
						</div>
					</div>
				</div>
			</vs-card>
			<vs-card class="w-1/2 card-block-child flex flex-col" style="padding-left: 5px; padding-right: 20px; margin-left: 20px; margin-right: -20px;">
				<!-- First div: 1/5 height -->
				<div style="padding-left: 15px; flex: 1;">
					<div class="vx-row w-full h-50 mt-2">
					<!-- Program End date -->
					<span class="title w-full" style="margin-bottom: 5px; font-size: 11px !important;">Fin de contrat demandée par le client</span>
					<span class="value" v-if="!contractToModify.edit" style="color: red;"><b>{{ contract.program_end_date ? convertDDMMYYY(contract.program_end_date) : "" }}</b></span>
					<div v-else class="w-full">
						<flat-pickr class="w-full" v-model="contractToModify.program_end_date" :config="configDatePicker" />
					</div>
					</div>
				</div>

				<!-- Second div: 2/5 height -->
				<div style="flex: 2;">
					<div class="mt-3 flex">
					<span class="title w-full" style="margin-bottom: 5px; font-size: 11px !important;">COMMENTAIRES</span>
					<vx-tooltip class="ml-3 cursor-pointer" :text = "contract.detail || nullValueMsg" position="right">
							<vs-icon icon="info" size="small" style="color: grey;"></vs-icon>
						</vx-tooltip>
					</div>
					<div class="vx-row w-full" style="overflow-y: scroll; max-height: 45px;">
					<vs-input class="inputx w-full" style="font-size: 11px;" v-if="contractToModify.edit" v-model="contractToModify.detail" />
					<span class="value" v-if="!contractToModify.edit" style="padding-left: 15px;font-size: 11px;"><b>{{ contract.detail || nullValueMsg }}</b></span>
					</div>
				</div>

				<!-- Third div: 2/5 height -->
				<div style="flex: 2;">
					<div class="mt-3 flex">
					<span class="title w-full" style="margin-bottom: 5px; font-size: 11px !important;">COMMENTAIRES FACTURATION</span>
					<vx-tooltip class="ml-3 cursor-pointer" :text = "contract.commentary || nullValueMsg" position="right">
							<vs-icon icon="info" size="small" style="color: grey;"></vs-icon>
						</vx-tooltip>
					</div>
					<div class="vx-row w-full" style="overflow-y: scroll; max-height: 45px;">
					<vs-input class="inputx w-full" style="font-size: 11px;" v-if="contractToModify.edit" v-model="contractToModify.commentary" />
					<span class="value" v-if="!contractToModify.edit" style="padding-left: 15px;font-size: 11px;"><b>{{ contract.commentary || nullValueMsg }}</b></span>
					</div>
				</div>
			</vs-card>

		</div>

		<vs-card v-if="allMissions" style="width: calc(100% + 19px); margin: 0 -10px 0 -12px; overflow-x: auto;">
			<div class="vx-row w-full mt-4" style="margin-top: -5px !important;">
				<div class="vx-row mt-4" style="width: calc(100% + 23px);">
					<div class="vx-col w-2/3" style="padding-left: 35px;">
						<span class="title-big w-full" style="vertical-align: middle; padding-right: 15px;">PRESTATIONS DU CONTRAT</span>
						<vs-switch v-if="![4, 5].includes(contract.status)" v-model="missionFilter" style="display: inline-flex; vertical-align: middle; width: 75px;">
							<span slot="on">EN COURS</span>
							<span slot="off">TOUS</span>
						</vs-switch>
					</div>
					<div v-if="activeUser.role != '2' && activeUser.type != '7'" class="vx-col w-1/3 text-right">
						<vs-button  @click="displayNewMissionPopup()" type="border" style="border-radius: 1px 6px 6px 6px; height: 32px; white-space: nowrap;">
							<div style="display: inline-block; vertical-align: middle; margin-top: -3px;">
								<div class="pen1" style="border-color: rgb(8, 176, 185);"></div>
								<div class="pen2">
									<div class="pen3" style="border-color: rgb(8, 176, 185);"></div>
									<div class="pen4" style="border-color: rgb(8, 176, 185);"></div>
								</div>
							</div>
							<div style="display: inline-block; margin-left: 5px;">Ajouter une prestation</div>
						</vs-button>
					</div>
				</div>
            </div>
			<div ref="newMissionContainer" class="w-full" style="padding: 11px;"></div>
			<MissionPopupTable :missions="filteredMissions" :contract="contract" :showupdate="true" @refresh-missions="refreshMissionTask" @update-contract-data="($event) => { $emit('update-contract-data', $event) }" style="margin-left:-10px; width: calc(100% + 20px);" :key="refreshMissionsList"/>
		</vs-card>

		<vs-card v-if="allMissions && activeUser.role != '2' && activeUser.type != '7'" style="width: calc(100% + 19px); margin: 20px -10px 0 -12px; overflow-x: auto;">
			<div class="vx-row w-full mt-4" style="margin-top: -5px !important;">
				<div class="vx-row mt-4" style="width: calc(100% + 23px);">
					<div class="vx-col w-1/2" style="padding-left: 35px;"><span class="title-big w-full">COMMANDES EN COURS</span></div>
					<div class="vx-col w-1/2 flex" style="justify-content: end;">
						<vs-button @click="showAllOrderPopup = true; $refs.orderTable.refreshList++;" type="border" style="border-radius: 1px 6px 6px 6px; height: 32px; white-space: nowrap; margin-right: 10px;">Voir toutes les commandes</vs-button>
						<vs-button @click="displayNewOrderPopup()" type="border" style="border-radius: 1px 6px 6px 6px; height: 32px; white-space: nowrap;">
							<div style="display: inline-block; vertical-align: middle; margin-top: -3px;">
								<div class="pen1" style="border-color: rgb(8, 176, 185);"></div>
								<div class="pen2">
									<div class="pen3" style="border-color: rgb(8, 176, 185);"></div>
									<div class="pen4" style="border-color: rgb(8, 176, 185);"></div>
								</div>
							</div>
							<div style="display: inline-block; margin-left: 5px;">Ajouter une commande</div>
						</vs-button>
					</div>
				</div>
			</div>
			<div ref="newOrderContainer" class="w-full" style="padding: 11px;"></div>
			<CommandeTable :orders="listOrders" :fromAllOrders="false" :contract="contract" :readOnly="false" @refresh-orders="refreshOrders" @duplicate-order="duplicateOrder($event)" style="margin-left:-10px; width: calc(100% + 20px);"  :key="refreshOrdersList" @show-order="displayNewOrderPopup()"/>
		</vs-card>

		<div class="vx-row w-full card-block" style="flex-wrap: nowrap; margin-top: 20px;">
			<vs-card v-if="activeUser.role != '2' && activeUser.type != '7'" class="w-1/2 card-block-child control-scrollbar" style="padding-top: 5px; margin-right: 20px;">
				<div style="display: flex;">
				<div class="vx-row w-full" style="margin-left: 12px;">
					<span class="title-big w-full">ACHATS</span>
				</div>
				<vs-button icon-pack="feather"
							icon="icon-plus"
							color="primary"
							@click="displayNewPurchasePopup(contract, null )"></vs-button>
							</div>

				<PurchasePopupTable :contract="contract" style="margin-left: -10px; width: calc(100% + 20px) !important;"/>
				<div class="vx-row my-auto w-full center">
					<vs-button icon-pack="feather" icon="icon-shopping-cart" type="border" style="border-radius: 1px 6px 6px 6px; height: 32px;" @click="showPurchases()" >Consulter les achats</vs-button>
				</div>
			</vs-card>

			<vs-card class="w-1/2 card-block-child control-scrollbar" style="padding-top: 5px; margin-right: -20px;">
				<div class="vx-row w-full" style="margin-left: 12px;">
					<span class="title-big w-full">TÂCHES</span>
				</div>
				<TaskMonitoringTable ref="taskmonitoring" :contract="contract" :thisTasks="contractTasks" :key="refreshTasksMonitorKey"
				style="margin-left: -10px; width: calc(100% + 20px) !important;"/>
				<div class="vx-col my-auto w-full flex center">
					<vs-button icon-pack="feather" icon="icon-list" type="border" style="border-radius: 1px 6px 6px 6px; height: 32px;" @click="showTasks" >Consulter les tâches <span v-if="waiting_task_count > 0" style="border-radius: 5px; background-color: rgb(140, 23, 164); color: white;" class="px-2 ml-1">{{ waiting_task_count }}</span></vs-button>
				</div>
			</vs-card>
		</div>

		<vs-card class="control-scrollbar" style="width: calc(100% + 19px); margin: 0 -10px 0 -12px;" v-if="$acl.check('noextern') && activeUser.role != '2' && activeUser.type != '7'">
          <div class="vx-row w-full mt-4" style="margin-top: -12px !important;">
            <div class="vx-col w-full">
              <FacturationTable :contract_id="$props.contract.id" :doImport=false style="margin-top: 15px; margin-left:-10px; width: calc(100% + 44px);"/>
            </div>
          </div>
		</vs-card>

		<vs-card v-if="activeUser.role != '2' && activeUser.type != '7'" class="control-scrollbar control-scrollbar-doc" style="width: calc(100% + 19px); margin: 20px -10px 0 -12px;">
			<div class="vx-row w-full mt-4" style="margin-top: -5px !important;">
				<div class="vx-row w-full mt-4">
					<div class="vx-col w-2/3" style="padding-left: 35px;">
						<span class="title-big w-full">DOCUMENTS DU CONTRAT</span>
					</div>
				</div>
			</div>
			<ContractDocumentsTable :contract_id="$props.contract.id" :contract_documents="allContractDocuments" :typeList="typeList" @open-confirmation="validationDeletePopup($event)" style="margin-left:-10px; width: calc(100% + 20px);"/>
            <div class="vx-row w-full card-block-flex" style="justify-content: start; margin-top: 10px; flex-wrap: nowrap;">
                <div class="vx-col w-1/2 flex card-block-btn">
					<div class="vx-col flex" style="margin-left: 10px;">
						<vs-input
							class="inputx w-full"
							placeholder="Lien vers le document"
							v-model="addDocLink"
							:style="styleValidator('docLink')"
							@change="validateOne(addDocLink, 'docLink')"
						/>
						<vx-tooltip v-if="validators['docLink'] && validators['docLink'].errText !== ''" :text="errText('docLink')" class="ml-3">
							<vs-icon icon="error" size="medium" style="color: red;"></vs-icon>
						</vx-tooltip>
					</div>
					<div class="vx-col flex" style=" margin-left: 10px;">
						<vs-select
							v-model="addDocType"
							class="select-medium mr-2"
							style= "width: 100%;"
							autocomplete
						>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.type_name"
							v-for="(item, index) in typeList"
							class="w-full width-select"
						/>
						</vs-select>
					</div>
					<div class="vx-col flex" style="margin-left: 10px;">
						<vs-input
							class="inputx"
							placeholder="Nom du document"
							v-model="addDocName"
							:style="styleValidator('docName')"
							@change="validateOne(addDocName, 'docName')"
						/>
						<vx-tooltip v-if="validators['docName'] && validators['docName'].errText !== ''" :text="errText('docName')" class="ml-3">
							<vs-icon icon="error" size="medium" style="color: red;"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
                <div class="vx-col flex w-1/2 card-block-btn" style="justify-content: right; padding: 0;">
					<vs-button
						icon-pack="feather"
						icon="icon-plus-circle"
						color="primary"
						type="border"
						style="border-radius: 1px 6px 6px 6px; width: 90px; height: 32px; margin-right: 15px;"
						@click="validateAll()"
					>
						Ajouter
					</vs-button>
					<a href="https://drive.google.com/drive/folders/1g62oL5DFr4BDuYAQo8LlY_5dmeIRJUvk" target="_blank">
						<vs-button
							icon-pack="feather"
							icon="icon-link"
							color="primary"
							type="border"
							style="border-radius: 1px 6px 6px 6px; width: 235px; white-space: nowrap; height: 32px;"
						>Lien vers le document de dépôt
						</vs-button>
					</a>
                </div>
            </div>
		</vs-card>

		<vs-card v-if="historyLogs == true && activeUser.role != '2' && activeUser.type != '7'" style="width: calc(100% + 19px); margin: 20px -10px 0 -12px; overflow-x: auto;">
            <div class="vx-row w-full mt-4" style="margin-top: -5px !important;">
				<div class="vx-row w-full mt-4">
					<div class="vx-col w-2/3" style="padding-left: 35px;">
						<span class="title-big w-full">HISTORIQUE DES ACTIONS</span>
					</div>
				</div>
			</div>
            <ActionHistoryTable :contract_id="$props.contract.id" :missionExisting="allMissions" style="margin-left:-10px; width: calc(100% + 20px);"/>
		</vs-card>

        <vs-popup
          :title="'Achats'"
          :active.sync="purchasesDisplayed"
        >
			<div class="vx-row">
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="accountManagerFilter"
						class="w-full select-large"
						placeholder="Ajouté par"
						autocomplete
						@change="purchasesFilter"
					>
						<vs-select-item
							value=""
							text="Ajouté par"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.id + 1"
							:text="item.firstname + ' ' + item.lastname"
							v-for="(item, index) in allCollaborators"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-input class="inputx" placeholder="N° Contrat" v-model="contractNumberFilter" @input="purchasesFilter"/>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="societyFilter"
						class="w-full select-large"
						placeholder="Client"
						autocomplete
						@change="purchasesFilter"
					>
						<vs-select-item
							value=""
							text="Client"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.id + 1"
							:text="item.name"
							v-for="(item, index) in societies"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="expertiseFilter"
						class="w-full select-large"
						placeholder="Service"
						autocomplete
						@change="purchasesFilter"
					>
						<vs-select-item
							value=""
							text="Service"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.id + 1"
							:text="item.name"
							v-for="(item, index) in services"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="providerFilter"
						class="w-full select-large"
						placeholder="Prestataire"
						autocomplete
						@change="purchasesFilter"
					>
						<vs-select-item
							value=""
							text="Tous les prestataires"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.id + 1"
							:text="item.society"
							v-for="(item, index) in providers"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col mb-2 px-1">
				<!-- DATE -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="calendar_today" size="small"></vs-icon
								></span>
							</div>
						</template>
						<flat-pickr
							class="w-full"
							v-model="dateFromFilter"
							placeholder="Date de début"
							:config="configDatePicker"
							@input="purchasesFilter"
						/>
					</vx-input-group>
				<!-- /DATE -->
				</div>
				<div class="vx-col mb-2 px-1">
				<!-- DATE -->
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
								><vs-icon icon="calendar_today" size="small"></vs-icon
								></span>
							</div>
						</template>
						<flat-pickr
							class="w-full"
							v-model="dateToFilter"
							placeholder="Date de fin"
							:config="configDatePicker"
							@input="purchasesFilter"
						/>
					</vx-input-group>
				<!-- /DATE -->
				</div>
				<div class="vx-col mb-2">
					<vx-input-group
						class="w-full bottom"
					>
						<flat-pickr
							class="w-full"
							v-model="periodFilter"
							placeholder="Période"
							:config="configPeriodPicker"
							@input="purchasesFilter"
						/>
					</vx-input-group>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="billableFilter"
						class="w-full select-large"
						placeholder="Facturable et Refacturable"
						autocomplete
						@change="purchasesFilter"
					>
						<vs-select-item
							value=""
							text="Facturable et Refacturable"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.value + 1"
							:text="item.text"
							v-for="(item, index) in billableOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div v-if="$acl.check('financeadmin')" class="vx-col mb-2 px-1 pt-2">
					<vs-switch color="primary" v-model="invoiceFilter" style="width: 105px;" @change="purchasesFilter">
						<span slot="off">Tous les achats</span>
						<span slot="on">Achats à rapprocher</span>
					</vs-switch>
				</div>
			</div>
			<PurchasesTable :purchases="filteredPurchases" @modify-purchase="modifyPurchase($event)" @renew-purchase="renewPurchase($event)" id="purchasePopup" :key="refreshPurchases"/>
        </vs-popup>
          <TaskHistoryPopup :tasks="contractTasks"
            :popupActive.sync="tasksDisplayed"
            :apiUrl="apiUrl"
			:key="refreshTasksKey"
            @refresh-task="refreshMissionTask()"
          />

		<vs-popup
			:active.sync="showValidateTaskTablePopup"
			title="Veuillez vérifier les tâches de ce contrat avant de le terminer."
			button-close-hidden
		>
			<ValidateTaskTable
				v-if="showValidateTaskTablePopup"
				:tasks="pendingTasks"
				:apiUrl="apiUrl"
				:contractId="contract.id"
			/>
			<div class="vx-row">
				<div class="vx-col w-1/2">
					<vs-button
						color="danger"
						class="mt-2 w-full"
						@click="declineTaskValidate()"
						>Annuler</vs-button
					>
				</div>
				<div class="vx-col w-1/2">
					<vs-button
						color="success"
						class="mt-2 w-full"
						@click="acceptTaskValidate()"
						>Continuer</vs-button
					>
				</div>
			</div>
		</vs-popup>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import ActionHistoryTable from "@/components/tables/ActionHistoryTable";
import PurchaseForm from "@/components/forms/purchase/Purchase";
import Contract from "@/entities/Contract";
import ContractDocumentsTable from "@/components/tables/ContractDocumentsTable";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import Mission from "@/entities/Mission";
import MissionForContract from "@/components/forms/mission/MissionForContract";
import FacturationTable from "@/components/tables/FacturationTable";
import MissionPopupTable from "@/components/tables/MissionPopupTable";
import CommandeTable from "@/components/tables/CommandeTable";
import Order from "@/components/forms/order/Order";
import Purchase from "@/entities/Purchase";
import PurchasePopupTable from "@/components/tables/PurchasePopupTable";
import PurchasesTable from "@/components/tables/PurchasesTable";
import TaskMonitoringTable from "@/components/tables/TaskMonitoringTable";
import ValidateTaskTable from "@/components/tables/ValidateTaskTable";
import TaskHistoryPopup from "@/components/popups/TaskHistoryPopup";
import AllNotesPopup from "@/components/popups/AllNotesPopUp";
import store from "@/store/store";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import Validator from "@/entities/Validator";
import Vue from "vue";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import HistoricalPurchasesPopup from "@/components/popups/HistoricalPurchasesPopup";
import "flatpickr/dist/plugins/monthSelect/style.css";



export default {
	name: "ContractInfoPopup",
	props: {
		contract: Object,
		popupActive: Boolean,
		router: Object,
		highZIndex: {
			type: Boolean,
			default: false
		},
		allowEdit: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		PurchaseForm,
		HistoricalPurchasesPopup,
		ActionHistoryTable,
		CommandeTable,
		ContractDocumentsTable,
		flatPickr,
		MissionForContract,
		MissionPopupTable,
		monthSelect,
		FacturationTable,
		Order,
		PurchasePopupTable,
		PurchasesTable,
		TaskMonitoringTable,
		TaskHistoryPopup,
		ValidateTaskTable
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		tasks: () => {
			return store.state.tasks;
		},
		activeUser(){
			return VueCookies.get("userInfo");
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allContractsDocumentsTypes: () => {
			return store.state.contracts_documents_types;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		societies: () => {
			return store.state.societies;
		},

	},
	created() {
		try{
			this.allOrders = [];
			this.allMissions = [];

			Mission.getMissionsForContract(this.$props.contract.id, (err, res) => {
				this.allMissions = res;
				for(let i = 0; i < this.allMissions.length; i++){
					this.allMissions[i]["products_number"] = i + 1;
				}
				this.filteredMissions = this.missionFilter == 1 && ![4, 5].includes(this.contract.status > 40 ? 4 : this.contract.status) ? res.filter(m => ![4, 5].includes(m.status)) : [...this.allMissions];
			});
			this.getAllOrdersForContract();
			// this.contractTasks = [];
			// for(let task of this.tasks){
			// 	if(task.contract_id == this.$props.contract.id){
			// 		this.contractTasks.push(task);
			// 	}
			// }
			this.getAllProductsCategories();
			this.getAllContractsLog();
			this.getCustomer();
			this.getAllType();
			this.getAllContractDocuments();
			this.getWaitingTasks();
			this.getTaskForContract();
			store.dispatch("getRedacLang");
			store.dispatch("getAllCollaborators");
			store.dispatch("getAllSocietiesIdAndName");
			store.dispatch("getAllServices");
			store.dispatch("getAllProviders");
			store.dispatch("getTaskByContractId", this.$props.contract.id);
			this.pauseStartDate= this.$props.contract.pause_start_date;
			this.pauseEndDate= this.$props.contract.pause_end_date;
			this.commercialOptions = this.allCollaborators.filter(collaborator => [4, 6, 9].includes(collaborator.type) && collaborator.status == 1).sort((a, b) => {
				return (a["firstname"]).localeCompare(b["firstname"]); //using String.prototype.localCompare()
			});
			this.accountmanagerOptions = this.allCollaborators.filter(collaborator => [3, 6, 7, 9].includes(collaborator.type) && collaborator.status == 1).sort((a, b) => {
				return (a["firstname"]).localeCompare(b["firstname"]); //using String.prototype.localCompare()
			});
			if(this.contract.account_manager_avatars){
				let lead = this.contract.account_manager_avatars.filter(a => a.is_lead);
				if(lead.length > 0) this.leadId = lead[0].users_id;
			}
			if(!this.$props.allowEdit){
				this.$vs.notify({
					title: "Attention",
					color: "warning",
					time: 5000,
					text: "Modification/ Ajout impossible. Passer par l'onglet Contrats pour effectuer cette action",
				});
			}

			window.isContractPopUp = true;
		}
		catch(e){
			console.error(e);
		}
		////console.log("contrtr", this.contract);
	},
	mounted() {
		this.getAllProductForCategory();
		this.commercialOptions = this.allCollaborators.filter(collaborator => [4, 6, 9].includes(collaborator.type) && collaborator.status == 1).sort((a, b) => {
			return (a["firstname"]).localeCompare(b["firstname"]); //using String.prototype.localCompare()
		});
		this.accountmanagerOptions = this.allCollaborators.filter(collaborator => [3, 6, 7, 9].includes(collaborator.type) && collaborator.status == 1).sort((a, b) => {
			return (a["firstname"]).localeCompare(b["firstname"]); //using String.prototype.localCompare()
		});
		if(this.contract.account_manager_avatars){
			let lead = this.contract.account_manager_avatars.filter(a => a.is_lead);
			if(lead.length > 0) this.leadId = lead[0].users_id;
		}
		// if(this.$props.contract.status == 4 && this.$props.contract.termination_reason_id > 0) this.$props.contract.status = this.sAdminStatusOptions.find(s => s.value == [4, this.$props.contract.termination_reason_id]).index;
		if(this.$props.contract.society_name){
			let popupTitle = document.querySelectorAll(".vs-popup--title");
			const clickEventData = {
				contract: this.$props.contract,
				societies: this.societies,
				router: this.$props.router,
				apiUrl: this.apiUrl,
				http: this.$http.get(this.apiUrl + "society/getImg/" + this.$props.contract.society_id),
				method: function(societyId){
					this.isPopupActive = false;
				

					
					this.selectedSociety = null; // Always reset data before assigning it
					this.selectedSociety = JSON.parse(JSON.stringify(clickEventData.societies.find(society => society.id == societyId)));
					clickEventData.http.then(image => {
						let imgObject = null;
						if(image.data.length > 0){
							imgObject = image.data;
						}

						this.selectedSociety.image = imgObject;
					}).catch(err => {
						//console.log(err);
					}).finally(res => {
					
						this.showSocietyPopup = true;

						//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
						let ComponentClass = Vue.extend(SocietyInfoPopup);
						let societyPopup = new ComponentClass({
							propsData: {
								society: this.selectedSociety,
								popupActive: this.showSocietyPopup,
								router: clickEventData.router,
								apiUrl: clickEventData.apiUrl
							}
						});
						societyPopup.$mount();
						this.$refs.popupContainer.appendChild(societyPopup.$el);
						// Loop through each element and remove it

					});
				}
			};
			for(let i = 0; i < popupTitle.length; i++){
				if(popupTitle[i].innerText == "Contrat n° " + this.$props.contract.id + "\n" + this.$props.contract.society_name){
					popupTitle[i].innerHTML = `<h3> Contrat n° ${this.$props.contract.id + "\n"}<b class="contractTitle"><span>${this.$props.contract.society_name}</span></b></h3>`;
					popupTitle[i].onclick = function(){
						clickEventData.method(clickEventData.contract.society_id);
					};
				}
			}
		}
	},
	watch: {
	
		"contract.id": {
			deep: true,
			handler(data) {
				try{
					if(this.contract.account_manager_avatars){
						let lead = this.contract.account_manager_avatars.filter(a => a.is_lead);
						if(lead.length > 0) this.leadId = lead[0].users_id;
					}
					this.allOrders = [];
					this.allMissions = [];
					Mission.getMissionsForContract(data, (err, res) => {
						if(err){
							//console.log("getMissionsForContract", err);
						}
						if(res){
							this.allMissions = res;
							//console.log("getMissionsForContract", res);
							for(let i = 0; i < this.allMissions.length; i++){
								this.allMissions[i]["products_number"] = i + 1;
							}
							this.filteredMissions = this.missionFilter == 1 && ![4, 5].includes(this.contract.status > 40 ? 4 : this.contract.status) ? res.filter(m => ![4, 5].includes(m.status)) : [...this.allMissions];
						}
					});
					this.getAllOrdersForContract();
				}
				catch(e){
					console.error(e);
				}

			}
		},
		allOrders: function(data){
			this.ordersFilter(data);
		},
		missionFilter: function(data){
			this.filteredMissions = data == 1 && ![4, 5].includes(this.contract.status > 40 ? 4 : this.contract.status) ? this.allMissions.filter(m => ![4, 5].includes(m.status)) : [...this.allMissions];
		},
		popupActive: function(){
			this.isPopupActive = this.popupActive;
		},
		isPopupActive: function(data){
			// clear the query params when the popup is closed
			if(data == false) this.clearQueryParams();
			this.$emit("update:popupActive", data);
		},
	},
	data() {
		return {
			contractToModify: JSON.parse(JSON.stringify(this.$props.contract)),
			contractStatus: String(this.$props.contract.status) + String(this.$props.contract.termination_reason_id),
			allContractDocuments: [],
			allMissions: [],
			allOrders: [],
			allPurchases: [],
			statusKey: 0,
			refreshPauseKey: 0,
			accountManagerFilter: "",
			billableFilter: "",
			ispurchasePopup: false,
			cloneListOrders: [],
			commercialOptions: [],
			contractNumberFilter: "",
			dateFromFilter: new Date(new Date().setMonth(new Date().getMonth() -2)).getDate() + "/" + String(Number(Number(new Date(new Date().setMonth(new Date().getMonth()-2)).getMonth())+1)) + "/" + new Date(new Date().setMonth(new Date().getMonth() -2)).getFullYear(),
			dateToFilter: new Date().getDate() + "/" + String(Number(Number(new Date().getMonth())+1)) + "/" + new Date().getFullYear(),
			expertiseFilter: "",
			providerFilter: "",
			societyFilter: "",
			invoiceFilter: 0,
			filteredMissions: [],
			filteredPurchases: [],
			products_categories: [],
			missionFilter: 1,
			errorFacturation: false,
			pauseStartDate: null,
			pauseEndDate: null,
			isPopupActive: this.popupActive,
			popupKey: 0,
			nullValueMsg: " ",
			purchasesDisplayed: false,
			tasksDisplayed: false,
			apiUrl: store.state.backendApiUrl,
			contractTasks: [],
			refreshTasksKey: 0,
			refreshTasksMonitorKey: 0,
			historyLogs: false,
			listFacture: [],
			leadId: 0,
			customers: [],
			//data Documents:
			typeList: [],
			docName: "",
			docId: null,
			validationPopup: false,
			addDocName: null,
			addDocLink: null,
			addDocType: 1,
			validators: [],
			check: false,
			loader: true,
			waiting_task_count: 0,
			showValidateTaskTablePopup: false,
			pendingTasks: [],
			skipTaskValidation: false,
			//new mission:
			showNewMissionPopup: false,
			refreshMissionsList: 0,
			billableOptions: [
				{text: "Facturable", value: 1},
				{text: "Non-facturable", value: 0}
			],
			configDatePicker: {
				dateFormat: "d/m/Y"
			},
			periodFilter: null,
			configPeriodPicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light"
					})
				],
			},
			refreshPurchases: 0,
			//orders:
			accountmanagerOptions: [],
			briefFilter: "",
			listOrders: [],
			orderAccountmanagerFilter: "",
			orderBillableFilter: "",
			orderProductFilter: "",
			orderStatusFilter: [],
			orderStatusOptions: [
				{text: "À faire", value: 1},
				// {text: "En cours", value: 2},
				{text: "Fait", value: 2},
				{text: "Annulé", value: 3},
				{text: "Terminée", value: 4},

			],
			productOptions: [],
			refreshEdit: 0,
			refreshOrdersList: 0,
			showAllOrderPopup: false,
			showNotesPopup: false,
			showNewOrderPopup: false,
			adminStatusOptions: [
				{text: "Actif", index: 10, value: [1, 0]},
				{text: "A\u00a0Valider", index: 20, value: [2, 0]},
				{text: "En\u00a0pause", index: 30, value: [3, 0]},
				{text: "Annulé", index: 50, value: [5, 0]},
			],
			sAdminStatusOptions: [
				{text: "Actif", index: 10, value: [1, 0]},
				// {text: "A\u00a0Validerx", index: 20, value: [2, 0]},
				// {text: "En\u00a0pause", index: 30, value: [3, 0]},
				{text: "Annulé", index: 50, value: [5, 0]},
				{text: "Relance", index: 90, value: [9, 0]},
				{text: "Terminé (Impayé)", index: 47, value: [4, 7]},
				{text: "Terminé (Insatisfaction client)", index: 41, value: [4, 1]},
				{text: "Terminé (Manque de résultat)", index: 42, value: [4, 2]},
				{text: "Terminé (Manque de budget)", index: 43, value: [4, 3]},
				{text: "Terminé (Prestation livrée)", index: 44, value: [4, 4]},
				{text: "Terminé (Fin de contrat)", index: 45, value: [4, 5]},
				{text: "Terminé (Autre)", index: 46, value: [4, 6]},
			],
			selectedSociety: "",
			// Obligatoire pour le popup SocietyInfoPopup
			obligatoryFields: {
				society_id: {
					required: true,
					errText: "Le champ Société est obligatoire.",
				},
				invoice_period: {
					required: true,
					errText: "Le champ Période de facturation est obligatoire.",
				},
				invoice_type: {
					required: true,
					errText: "Le champ Type de facturation est obligatoire.",
				},
				invoice_day: {
					required: true,
					errText: "Le champ Jour de facturation est obligatoire.",
				},
				status: {
					required: true,
					errText: "Le champ Statut est obligatoire.",
				},
				// commentary: {
				// 	required: true,
				// 	errText: "Le champ Commentaire est obligatoire.",
				// },

			},
		};
	},
	methods: {
		getTaskForContract(){
			this.$http.get(this.apiUrl + "task/getByContractId/" + this.contract.id).then(res => {
				this.contractTasks = res.data;
				this.refreshTasksKey++;
				// this.refreshTasksMonitorKey++;
			});
		},
		convertDDMMYYY(date){
			if(this.isDateFormatValid(date)) return date;
			return moment(date).format("DD/MM/YYYY");
		},
		isDateBeforeToday(date){
			return moment(date).isBefore(moment());
		},

		isDateFormatValid(dateString) {
		  // Parse the date using moment with the specified format
		  const parsedDate = moment(dateString, "DD/MM/YYYY", true);

		  // Check if the parsed date is valid and the input matches the desired format
		//   console.log(dateString);
		//   console.log(parsedDate.isValid() && parsedDate.format("DD/MM/YYYY") === dateString);
		//   console.log("parsedDate.isValid() && parsedDate.format('DD/MM/YYYY') === dateString");
		  return parsedDate.isValid() && parsedDate.format("DD/MM/YYYY") === dateString;
		},
		changeStatus(){
			console.log("message");
		},
		modifyContract(){
			
			if(this.$props.allowEdit){
			this.contractToModify.edit = true;
			this.refreshEdit++;
			}else{
				this.$vs.notify({
					title: "Echec",
					color: "warning",
					text: "Passer par l'onglet contrat.",
				});
			}
		},
		reloadStatus() {
			this.$http.get("contract/getStatusWithTermination/"+ this.contract.id).then(res => {
				//console.log("reloadStatus", res);
				this.contractStatus = res.data;
				this.statusKey++;
			})
				.catch(err => {
					console.error(err);
				});
		},
		displayNewMissionPopup() {
			if(!this.$props.allowEdit) return;
			if(this.$refs.newMissionContainer.children.length == 0){
				this.showNewMissionPopup = true;

				let ComponentClass = Vue.extend(MissionForContract);
				let missionPopup = new ComponentClass({
					propsData: {
						contract: this.contract,
						show: this.showNewMissionPopup,
						router: this.$router,
						apiUrl: this.apiUrl,
						editMode: false
					}
				});
				missionPopup.$mount();
				missionPopup.$on("close-form-after-added", (event) => {
					this.showNewMissionPopup = false;
					this.refreshMissions();
				});

				this.$refs.newMissionContainer.appendChild(missionPopup.$el);
			}
		},

		displayNotesPopup() {
			this.showNotesPopup = true;
			let ComponentClass = Vue.extend(AllNotesPopup);

			let notesPopup = new ComponentClass({
				propsData: {
					contract_id: this.contract.id,
					popupActive: true,
					router: this.$router,
					apiUrl: this.apiUrl,
				}
			});
			notesPopup.$mount();
			this.$refs.popupContainer.appendChild(notesPopup.$el);
		},
		displayNewOrderPopup() {
			if(this.$refs.newOrderContainer.children.length == 0){
				this.showNewOrderPopup = true;

				let ComponentClass = Vue.extend(Order);
				let orderPopup = new ComponentClass({
					propsData: {
						contract: this.contract,
						show: this.showNewOrderPopup,
						router: this.$router,
						apiUrl: this.apiUrl,
					}
				});
				orderPopup.$mount();
				orderPopup.$on("close-form-after-added", (event) => {
					this.showNewOrderPopup = false;
					this.refreshOrders();
				});

				this.$refs.newOrderContainer.appendChild(orderPopup.$el);
			}
		},

		duplicateOrder(order){
			this.displayNewOrderPopup();
			this.$refs.newOrderContainer.children[0].__vue__.order.billable = order.billable;
			this.$refs.newOrderContainer.children[0].__vue__.order.billable_price = order.billable_price;
			this.$refs.newOrderContainer.children[0].__vue__.order.brief_text = order.brief_text;
			this.$refs.newOrderContainer.children[0].__vue__.order.budget = order.budget;
			this.$refs.newOrderContainer.children[0].__vue__.order.contract_id = order.contract_id;
			this.$refs.newOrderContainer.children[0].__vue__.order.period = order.period;
			this.$refs.newOrderContainer.children[0].__vue__.order.product_id = order.product_id;
			this.$refs.newOrderContainer.children[0].__vue__.order.status = order.status;
			this.$refs.newOrderContainer.children[0].__vue__.order.account_manager_id = order.account_manager_id;
			this.$http.get(this.apiUrl + "shared_document/list/order_id/" + order.id).then(res => {
				if(res.data.length > 0){
					this.$refs.newOrderContainer.children[0].__vue__.docName = res.data[0].filename;
					this.$refs.newOrderContainer.children[0].__vue__.docType = res.data[0].document_type_id;
					this.$refs.newOrderContainer.children[0].__vue__.docLink = res.data[0].link;
				}
			});
		},

		purchasesFilter(){
			let tmp = [...this.allPurchases];
			if(this.accountManagerFilter) tmp = tmp.filter(p => p.user_id + 1 == this.accountManagerFilter);
			if(this.billableFilter) tmp = tmp.filter(p => p.is_billable + 1 == this.billableFilter);
			if(this.contractNumberFilter) tmp = tmp.filter(p => String(p.contract_id).includes(this.contractNumberFilter));
			if(this.expertiseFilter) tmp = tmp.filter(p => p.service_id + 1 == this.expertiseFilter);
			if(this.providerFilter) tmp = tmp.filter(p => p.users_id + 1 == this.providerFilter);
			if(this.societyFilter) tmp = tmp.filter(p => p.contract_society_id + 1 == this.societyFilter);
			if(this.periodFilter) tmp = tmp.filter(p => p.period_date.substr(0, 7).split("-").reverse().join("/") == this.periodFilter);
			let start = this.dateFromFilter.split("/");
			start[0] = String(start[0]).padStart(2, "0");
			start[1] = String(start[1]).padStart(2, "0");
			start = start.reverse().join("");
			let end = this.dateToFilter.split("/");
			end[0] = String(end[0]).padStart(2, "0");
			end[1] = String(end[1]).padStart(2, "0");
			end = end.reverse().join("");
			tmp = tmp.filter(p => p.recurrence_date ? parseInt(start) <= parseInt(p.recurrence_date.substr(0, 10).split("-").join("")) && parseInt(end) >= parseInt(p.recurrence_date.substr(0, 10).split("-").join("")): parseInt(start) <= parseInt(p.input_date.substr(0, 10).split("-").join("")) && parseInt(end) >= parseInt(p.input_date.substr(0, 10).split("-").join("")));
			tmp = this.invoiceFilter == 0 ? tmp : tmp.filter(p => !p.invoice_date);
			this.filteredPurchases = tmp;
			this.refreshPurchases++;
		},

		/**
		 * Query our API to fetch all product for a category
		 */
		getAllProductForCategory() {
			let deliveryId = this.contract.delivery;
			if(!deliveryId){
				deliveryId = 1;
			}
			this.$http
				.get(this.apiUrl + "product/all/" + deliveryId.toString())
				.then(res => {
					// //console.log(res);
					let cat = res.data[0].category;
					this.productOptions = res.data.filter(p => p.category == cat || p.category == 7);

					if(deliveryId == 7){
						this.productOptions = this.productOptions.filter(p => p.category == cat);
					}

					//console.log(this.productOption);
				})
				.catch(err => {
					console.error(err);
				});
		},

		getAllProductsCategories() {
			this.$http
				.get(this.apiUrl + "product/category/all")
				.then(res => {
					// //console.log("getAllProductsCategories", res.data);
					this.products_categories = res.data.map(row => row.name);
				})
				.catch(err => {
					console.error(err);
				});
		},

		ordersFilter(orders){
			let tmpList = [...orders];
			if(this.briefFilter != null) tmpList = tmpList.filter(o => o.brief_text.toLowerCase().indexOf(this.briefFilter.toLowerCase()) > -1);

			if(this.orderAccountmanagerFilter > 0) tmpList = tmpList.filter(o => o.account_manager_id == this.orderAccountmanagerFilter);
			if(this.orderProductFilter > 0) tmpList = tmpList.filter(o => o.product_id == this.orderProductFilter);

			if(this.orderStatusFilter.length > 0) tmpList = tmpList.filter(o => this.orderStatusFilter.indexOf(o.status) > -1);
			if(this.orderBillableFilter && this.orderBillableFilter > -1) tmpList = tmpList.filter(o => this.orderBillableFilter == o.billable);
			// //console.log(this.orderBillableFilter);
			this.listOrders = JSON.parse(JSON.stringify(orders));
			this.cloneListOrders = JSON.parse(JSON.stringify(tmpList));
		},

		refreshTasks(){
			// this.$refs.taskmonitoring.refreshTasks();
			// this.getTaskForContract();
			this.getWaitingTasks();
			this.getAllContractsLog();
		},
		refreshMissionTask(){
			this.refreshMissions();
			this.refreshTasks();
		},
		refreshMissions(){
			//dispatching inside store to update cotractsList
			store.dispatch("getAllContractsWithContractsUsers").then(() => {
				this.reloadStatus();
			});
			try{
				//console.log("refreshMissions", this.$props.contract.id);
				Mission.getMissionsForContract(this.$props.contract.id, (err, res) => {
					if(err){
						//console.log(err);
					}
					if(res){
						// //console.log("res", res);
						this.allMissions = res;
						for(let i = 0; i < this.allMissions.length; i++){
							this.allMissions[i]["products_number"] = i + 1;
						}
						this.filteredMissions = this.missionFilter == 1 && ![4, 5].includes(this.contract.status > 40 ? 4 : this.contract.status) ? res.filter(m => ![4, 5].includes(m.status)) : [...this.allMissions];
					}
				});
				this.getAllContractsLog();
				this.refreshMissionsList++;
			}
			catch(e){
				console.error(e);
			}
		},
		refreshOrders(){
			//console.log("popping");
			this.reloadStatus();
			this.getAllOrdersForContract();
		},
		modifyPurchase(purchase) {
			// Close popups first to avoid conflicts
			this.purchasesDisplayed = false;
			this.isPopupActive = false;
			
			// Use $nextTick to ensure DOM updates complete before navigation
			this.$nextTick(() => {
				this.$emit("modify-purchase", purchase);
				this.$emit("update:popupActive", false);
			});
			
			this.getAllContractsLog();
		},
		renewPurchase(purchaseId){
			this.purchasesDisplayed = false;
			this.$emit("renew-purchase", purchaseId);
			this.$emit("update:popupActive", false);
			this.isPopupActive = false;
			this.getAllContractsLog();
		},
		showPurchases(){
			try{
				Purchase.getAllPurchasesWithRecurringForContract(this.contract.id, (err, res) => {
					if(err) console.error(err);
					if(res){
						let sortedData = [...res.data];
						sortedData.sort((a, b) => {
							// Use toUpperCase() to ignore character casing
							const dateA = a.recurrence_date ? new Date(a.recurrence_date.substring(0, 10)) : new Date(a.bought_at.substring(0, 10));
							const dateB = b.recurrence_date ? new Date(b.recurrence_date.substring(0, 10)) : new Date(b.bought_at.substring(0, 10));

							let comparison = 0;
							if(dateA < dateB) {
								comparison = 1;
							}
							else if(dateA > dateB) {
								comparison = -1;
							}
							return comparison;
						});
						this.allPurchases = sortedData;
						this.filteredPurchases = this.allPurchases;
						this.purchasesDisplayed = true;
					}
				});
			}
			catch(e){
				console.error(e);
			}

		},
		showTasks(){
			// Load fresh task data before opening the popup
			this.getTaskForContract();
			this.tasksDisplayed = true;
		},

		acceptTaskValidate() {
			this.showValidateTaskTablePopup = false;
			// Set flag to skip task validation and continue with contract termination
			this.skipTaskValidation = true;
			this.updateContract();
		},

		declineTaskValidate() {
			this.showValidateTaskTablePopup = false;
			// Reset the status dropdown to previous value
			this.reloadStatus();
		},

		// TODO Add contractMissions
		async terminateAllMissions(){
			// Get all missions for contract
			let contractMissions = await Mission.getMissionsForContractAsync(this.contract.id);
			//console.log("Missions are updating...", contractMissions);
			for(let mission of contractMissions){
				let missionToUpdate = new Mission(mission);
				missionToUpdate.status = 4;
				//console.log(missionToUpdate);
				missionToUpdate.update();
			}
		},
		async updateContract(){
			let modifiedStatus = Number(String(this.contractStatus)[0]);
			// checking if the status is paused
			// if(modifiedStatus == 3) {
			// 	// evaluating if the pause start date is before or same as today if not the contract goes to active untill the day arrives
			// 	if (!this.pauseStartDate) this.pauseStartDate = moment().format("DD/MM/YYYY");
			// 	// let varPauseDateStart= moment(this.pauseStartDate.split("/").reverse().join("-"));
			// 	// let isBeforeOrSamePauseDate = varPauseDateStart.isSameOrBefore(moment())
			// 	// if(isBeforeOrSamePauseDate) modifiedStatus = 3;
			// 	// else modifiedStatus = 1;
			// }
			// assign the contract status 
			// Check if the contract is paused and the pause start date is not set
			if (this.pauseEndDate) {
				if(!this.pauseStartDate) {
					this.$vs.notify({
						title: "Attention",
						color: "warning",
						text: "Veuillez renseigner la date de début de pause.",
					});
					return;
				}
			}
				// ✅ NEW LOGIC: If status is "en pause" (3) but no pause dates are set, convert to active (1)
			if (modifiedStatus === 3 && !this.pauseStartDate && !this.pauseEndDate) {
				modifiedStatus = 1; // Convert to active status
				
				// Optional: Show notification to user about the automatic conversion
				this.$vs.notify({
					title: "Information",
					color: "primary",
					text: "Statut automatiquement converti en actif car aucune date de pause n'est définie."
				});
			}
			
			// ✅ Check for running tasks before allowing contract termination (status 4)
			if (modifiedStatus === 4 && !this.skipTaskValidation) {
				try {
					const response = await this.$http.get(
						this.apiUrl + "task/getRunningTasksforContract/" + this.contractToModify.id
					);
					
			if (response.data && response.data.length > 0) {
				// Store tasks and show validation popup
				this.pendingTasks = response.data;
				this.showValidateTaskTablePopup = true;
				return;
			}
				} catch (error) {
					console.error("Erreur lors de la vérification des tâches en attente:", error);
					this.$vs.notify({
						title: "Erreur",
						color: "danger",
						position: "bottom-right",
						text: "Une erreur s'est produite lors de la vérification des tâches en attente."
					});
					return;
				}
			}
			// Reset the skip flag
			this.skipTaskValidation = false;
			this.contractToModify.status = modifiedStatus;

			let editParams = {
				id: this.contractToModify.id,
				type: this.contractToModify.type,
				creation_date: this.contractToModify.creation_date.replace(/T|Z/g, " "),
				start_date: this.contractToModify.start_date ? this.contractToModify.start_date.replace(/T|Z/g, " ") : this.contractToModify.start_date,
				end_date: this.contractToModify.end_date ? this.contractToModify.end_date.replace(/T|Z/g, " ") : this.contractToModify.end_date,
				commentary: this.contractToModify.commentary,
				detail: this.contractToModify.detail,
				delivery: this.contractToModify.delivery,
				estimate_link: this.contractToModify.estimate_link,
				pause_start_date: this.pauseStartDate? this.pauseStartDate.split("/").reverse().join("-"): null,
				pause_end_date: this.pauseEndDate?this.pauseEndDate.split("/").reverse().join("-"): null,
				bccgv_link: this.contractToModify.bccgv_link,
				society_id: this.contractToModify.society_id,
				invoice_period: this.contractToModify.invoice_period,
				invoice_delay_time: this.contractToModify.invoice_delay_time,
				invoice_type: this.contractToModify.invoice_type,
				commercial_id: this.contractToModify.commercial_id,
				status: modifiedStatus,
				max_budget: 0,
				users_id: this.activeUser.id,
				early_cancellation: this.contractToModify.early_cancellation,
				early_cancellation_duration: this.contractToModify.early_cancellation_duration,
				engagement_duration: this.contractToModify.engagement_duration,
				termination_reason_id: Number(String(this.contractStatus)[1]),
				program_end_date: this.contractToModify.program_end_date ? this.contractToModify.program_end_date.split("/").reverse().join("-").replace(/T|Z/g, " ") : null,
			}

			for(let key in editParams){
				if (this.obligatoryFields[key] && this.obligatoryFields[key].required && !editParams[key])
				 {
					this.$vs.notify({
					title: "Attention",
					color: "warning",
					text: this.obligatoryFields[key].errText,
				});
				return;
				}
			}
						this.$vs.loading({
				container: "#modifyButton",
				scale: 0.6
			});
			this.$http.post(this.apiUrl + "contract/edit", editParams ).then(async() => {
				// if(modifiedStatus == 4) this.terminateAllMissions();
				let newContract = new Contract(JSON.parse(JSON.stringify(this.contractToModify)));
				try{
				let newAccountmanagerList = this.contractToModify.account_manager_avatars && this.contractToModify.account_manager_avatars.length > 0 ? this.contractToModify.account_manager_avatars.filter(a => a.users_id != this.leadId && !a.is_lead) : [];
				if(this.leadId > 0) newAccountmanagerList.push({name: this.accountmanagerOptions.find(c => c.id == this.leadId).firstname + " " + this.accountmanagerOptions.find(c => c.id == this.leadId).lastname, users_id: this.leadId, id: this.leadId, is_lead: 1});
				newContract["account_managers"] = JSON.parse(JSON.stringify(newAccountmanagerList));
				let oldAMList = this.contractToModify.account_manager_avatars && this.contractToModify.account_manager_avatars.length > 0 ? JSON.parse(JSON.stringify(this.contractToModify.account_manager_avatars)) : [];
				for(let a of oldAMList){
					a["id"] = a.users_id;
				}
				await newContract.updateUserRelation(this.contractToModify.id, oldAMList, this.activeUser.id);
				this.$http.get(this.apiUrl + "mission/get/contract/" + this.contractToModify.id)
					.then(async(res) => {
						if(this.leadId > 0){
							let lead = newAccountmanagerList.find(manager => manager.is_lead);
						}
						this.contract = JSON.parse(JSON.stringify(this.contractToModify));
						this.contract["account_manager_avatars"] = JSON.parse(JSON.stringify(newAccountmanagerList));
						this.$emit("refresh-lead");
						let foundCommercial = this.commercialOptions.find(c => c.id == this.contract.commercial_id);
						this.contract.commercial_name = foundCommercial ? foundCommercial.firstname + " " + foundCommercial.lastname : " ";
					})
				}
				catch(e){
					this.$vs.notify({
						title: "Attention",
						color: "warning",
						text: "Le contrat relation n'a pas été modifié.",
					});
				}
				this.$vs.loading.close("#modifyButton > .con-vs-loading");
						// Send a success notification to the user
						this.$vs.notify({
							title: "Succès",
							text: "Contrat modifié avec succès."
						});
						this.contractToModify.edit = false;
						this.refreshCommercialNotifications();
						await this.refreshMissions();
						this.refreshEdit++;
			}).catch(err => {
				this.$vs.loading.close("#modifyButton > .con-vs-loading");
				this.$vs.notify({
					title: "Echec",
					text: "Le contrat n'a pas été modifié."
				});
			});

		},

		refreshCommercialNotifications(){
			store.dispatch("getAllNotifications");
		},

		updateMissions(contractId){
			sessionStorage.setItem("popupOrigin", contractId);
			this.isPopupActive = false;
			this.$emit("update:popupActive", false);
			this.$emit("modify-missions", contractId);
		},
		getCollaboratorAvatar(userId){
			try{
				let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
				if(foundAvatar) return foundAvatar.avatar;
				else return null;
			}
			catch(e){
				console.error(e);
			}

		},

		downloadBccgv(contractId){
			// //console.log(contractId);
			let target_url = this.apiUrl + "contract/getBccgv/" + contractId;
			this.$http.get(target_url, {responseType: "blob"})
				.then(fetched_bccgv => {
					let fileURL = window.URL.createObjectURL(new Blob([fetched_bccgv.data]));
					let fileLink = document.createElement("a");
					// //console.log("fetched_bccgv", fetched_bccgv);
					fileLink.href = fileURL;
					fileLink.setAttribute("download", "contract-" + contractId + ".pdf");
					document.body.appendChild(fileLink);
					fileLink.click();
				})
				.catch(err => {
					//console.log(err);
				});
		},
		getAllContractsLog(){
			try{
				this.$http.get(this.apiUrl + "logger/contract/all/" + this.$props.contract.id)
					.then(result => {
						if(result.data.length == 0) this.historyLogs = false;
						if(result.data.length > 0) this.historyLogs = true;
					})
					.catch(error => {
						//console.log(error);
					});
			}
			catch(e){
				console.error(e);
			}

		},

		getCustomer(){
			// try{
			// 	this.$http.get(this.apiUrl + "pending_invoices/customers/society/" + this.contract.society_id)
			// 		.then(res => {
			// 			if(res.data.length > 0){
			// 				this.$http.get(this.apiUrl + "qb/invoices_by_contract/" + this.$props.contract.id)
			// 					.then(result => {
			// 						console.log("INVOICE S", result);
			// 						this.listFacture = result.data;
			// 						this.loader = false;
			// 					})
			// 					.catch(error => {
			// 						//console.log(error);
			// 					});
			// 			}
			// 			else{
			// 				this.loader = false;
			// 			}
			// 		})
			// 		.catch(err => {
			// 			this.errorFacturation = true;
			// 			this.loader = false;
			// 		});
			// }
			// catch(e){
			// 	console.error(e);
			// }

		},

		getAllContractDocuments(){
			try{
				this.$http.get(this.apiUrl + "contracts_documents/list/contract/" + this.$props.contract.id)
					.then(res => {
						if(res.data.length > 0){
							this.allContractDocuments = res.data;
						}
						else{
							this.allContractDocuments = [];
						}
					})
					.catch(error => {
						//console.log(error);
					});
			}
			catch(e){
				console.error(e);
			}
		},
		/**
		 * @function getAllOrdersForContract - get all orders info for selected contract
		 */
		getAllOrdersForContract(){
			try{
				this.$http.get(this.apiUrl ? this.apiUrl + "orders/get/contract/" + this.$props.contract.id : store.state.backendApiUrl + "orders/get/contract/" + this.$props.contract.id)
					.then(res => {
						if(res.data.length > 0){
							store.dispatch("setAllUserCommandes", {allOrders: res.data});
							this.allOrders = store.getters.getAllCommandes;
						}
						else{
							this.allOrders = [];
						}
					})
					.catch(error => {
						//console.log(error);
					});
			}
			catch(e){
				console.error(e);
			}

		},

		getEarlyCancellation(month){
			if(month > 0) return month + " mois";
			else return "Non";
		},

		getWaitingTasks(){
			try{
				this.$http.get(this.apiUrl + "task/getWaitingTasks/" + this.contract.id).then(res => {
					this.waiting_task_count = res.data[0].waiting_task_count;
					this.refreshTasksMonitorKey++;
				})
					.catch(error => {
						//console.log(error);
					});
			}
			catch(e){
				console.error(e);
			}

		},

		//Operations Documents: edit/delete

		validationDeletePopup(doc){
			this.docName = doc[1];
			this.docId = doc[0];
			this.validationPopup = true;
		},
		deleteDoc(){
			try{
				this.$http.delete(this.apiUrl + "contracts_documents/delete/document/" + this.docId + "/" + this.activeUser.id)
					.then(result => {
						this.validationPopup = false;
						this.allContractDocuments = [];
						this.$nextTick(() => {
							this.getAllContractDocuments();
						});
					})
					.catch(error => {
						//console.log(error);
					});
			}
			catch(e){
				console.error(e);
			}

		},
		cancelDelete(){
			this.validationPopup = false;
		},

		//add Document

		getAllType(){
			this.$http.get(this.apiUrl + "contracts_documents/list/doctype/all")
				.then(result => {
					this.typeList = result.data;
				})
				.catch(error => {
					//console.log(error);
				});
		},
		validateDateDebut(missionDateDebut) {
			if (missionDateDebut != null && this.mission.mission_duration != null) {
				// only if it is not edit mode
				if (!this.$props.editMode)
					this.mission.estimated_end_date = this.calculateEstimatedEndDate(
						missionDateDebut,
						this.mission.mission_duration
					);
				this.validateOne(missionDateDebut, "missionStartDate");
			}
		},
		validateOne(val, name){
			let value = val;
			let constname = "";
			name == "docName" ? constname = "rnameConstraint" : constname = "linkConstraint";
			this.validators[name] = new Validator({constraintName: constname});
			this.validators[name].check(value);
			this.validators[name].errText == "" && this.validators[name].valid == false ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
			this.validators[name].valid == false ? this.check = false : "";
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators[name] && this.validators[name].valid == false){
				return "border: 1px solid red !important; border-radius: 5px;";
			}
			else if(this.validators[name] && this.validators[name].valid == true){
				return "border: 1px solid green !important; border-radius: 5px;";
			}
			else{
				return "";
			}
		},
		validateAll() {
			try{
				this.check = true;
				let fields = ["docName", "docLink"];
				for(let i = 0; i < fields.length; i++){
					let name = "";
					let value = "";
					if(fields[i] == "docName"){
						name = "rnameConstraint";
						value = this.addDocName;
					}
					else{
						name = "linkConstraint";
						value = this.addDocLink;
					}
					this.validators[fields[i]] = new Validator({constraintName: name});
					this.validators[fields[i]].check(value);
					this.validators[fields[i]].errText == "" && this.validators[fields[i]].valid == false ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
					this.validators[fields[i]].valid == false ? this.check = false : "";
					this.$forceUpdate();
				}
				if(this.check){
					this.$http.post(this.apiUrl + "contracts_documents/add", {
						filename: this.addDocName,
						link: this.addDocLink,
						contract_id: this.$props.contract.id,
						contract_document_type_id: this.addDocType,
						user_id: this.activeUser.id,
					}).then(() => {
						this.allContractDocuments = [];
						this.$nextTick(() => {
							this.getAllContractDocuments();
						});
					})
						.catch(error => {
							//console.log(error);
						});
				}
			}
			catch(e){
				console.error(e);
			}

		},
		displayNewPurchasePopup(contract, missionId) {
			this.showNewPurchasePopup = true;

			let ComponentClass = Vue.extend(HistoricalPurchasesPopup);
			let newPurchasePopup = new ComponentClass({
				propsData: {
					missions: this.filteredMissions,
					apiUrl: this.apiUrl,
					missionId: missionId,
					popupActive: this.showNewPurchasePopup,
					contractId: contract.id,
					societyId: contract.society_id,
					societyName: contract.society_name,
					societies: this.societies,
					providers: this.providers,
					services: this.services,
					products_categories: this.products_categories
				},


			});
			newPurchasePopup.$mount();
			newPurchasePopup.$on("update:popupActive", () => {
				//this.refreshTask()
			});
			newPurchasePopup.$on("refresh-data", () => {
				this.$emit("refresh-data");
				//this.refreshTask()
			});
			this.$refs.popupContainer.appendChild(newPurchasePopup.$el);
		},
			/**
			 * @function clearQueryParams - clears the query params
			 */
clearQueryParams() {
	const currentQuery = { ...this.$route.query };
	delete currentQuery.contract_id;
	
	this.$router.replace({ 
		path: this.$route.path, 
		query: currentQuery 
	}).catch(err => {
		if (err.name !== 'NavigationDuplicated') {
			console.error('Router error:', err);
		}
	});
}
	},


};
</script>

<style>
.contractTitle:hover{
	cursor: pointer;
	color: rgb(8, 176, 185);
}
.title {
  color: grey;
  font-size: 11px;
}

.title-big {
  color: black;
  font-size: 17px;
}

.value {
  color: black;
  font-weight: 500;
  font-size: 16px;
}

.center {
  justify-content: center;
}

#contractPopup {
  width: auto;
}
.con-vs-popup .vs-popup  {
  width: auto;
}
.vs-tooltip.vs-tooltip-top.vs-tooltip-null{
  word-break: break-all;
}

/*popup*/


.contract-status {
	position: fixed;
	margin-top: -110px !important;
	padding-left: 10px;
	max-width: 1000px;
	min-width: 900px;
}

i {
	align-self: start;
}

i.feather {
	align-self: center;
}

.width-select>.input-select-con {
	width: 150px;
}

.h-50 {
	height: 50%;
}
.pen1 {
	display: inline-block;
	width: 5px;
	height: 5px;
	background-color: transparent;
	border: 1px solid white;
	transform: rotate(45deg);
	float: right;
}
.pen2 {
	display: inline-block;
	transform: rotate(45deg);
	margin-left: -13px;
}
.pen3 {
	display: inline-block;
	width: 5px;
	height: 10px;
	background-color: transparent;
	border: 1px solid white;
	border-bottom-color: transparent;
	margin-left: 4px;
}
.pen4 {
	display: inline-block;
	width: 3.3px;
	height: 3.3px;
	border-left: 1px solid white;
	border-bottom: 1px solid white;
	transform: rotate(-45deg);
	margin-bottom: -2px;
	margin-left: -4px;
}

th {
	pointer-events: none;
	padding-top: 5px !important;
	padding-bottom: 5px !important;
}
.vertical-start {
	align-content: start;
}

.vs-button-text.vs-button--text {
	align-self: self-end;
}
.vs-card--content {
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	height: 100%;
}

.vs-con-tbody.vs-table--tbody {
	overflow: visible;
}

.con-tablex.vs-table--content {
	overflow: visible;
}

.vs-popup--header+div {
	max-height: calc(100vh - 150px) !important;
}
.vs-popup {
	min-width: 1050px;
}
.vs-popup--title > h3 {
	color: white;
	font-size: 23px;
	font-weight: 400;
	white-space: break-spaces;
	text-align: center;
}
.vs-popup--header {
	background-color: #0C293D;
	border-radius: 5px 5px 0 0;
	height: 106px;
}
.red {
  color: red;
}

@media (min-width: 560px) and (max-width: 1090px){
	.vs-popup{
		min-width: 500px;
		width: 100%;
	}
	.contract-status{
		min-width: 0 !important;
	}
	.card-block{
		flex-direction: column;
	}
	.card-block-child{
		width: calc(100% + 20px) !important;
		margin-left: 0 !important;
	}
	.card-block-btn{
		width: 100% !important;
		justify-content: center !important;
		margin-bottom: 10px;
		min-width: 450px;
	}
	.card-block-flex{
		flex-wrap: wrap !important;
	}
	.title-btn{
		padding-right: 100px !important;
	}

	.tr2{
		padding-right: 12% !important;
	}
}

@media (max-width: 680px){
	.control-scrollbar.control-scrollbar-doc{
		overflow-x: auto;
	}
}

@media (max-width: 559px){
	.vs-popup{
		min-width: 50px;
		width: 100%;
	}
	.control-scrollbar{
		overflow-x: auto;
	}
	.contract-status{
		position: relative !important;
		top:-20px;
		min-width: 0 !important;
		flex-direction: column;
		justify-content: center;
	}
	.card-block{
		flex-direction: column;
	}
	.card-block-child{
		width: calc(100% + 20px) !important;
		margin-left: 0 !important;
	}
	.card-block-btn{
		width: 100% !important;
		justify-content: center !important;
		margin-bottom: 10px;
		min-width: 450px;
	}
	.card-block-flex{
		flex-wrap: wrap !important;
	}
	.title-btn{
		padding-right: 100px !important;
	}
	.infocard{
		flex-direction: column !important;
	}
	.infocard-col{
		margin-left: -13px !important;
		width: 100% !important;
	}
	.infocard-col>span{
		margin-left: 0 !important;
	}
}
</style>